/*************************************************/
/* MAP                                           */
/*************************************************/
export function map() {
    const mapMarkers = document.querySelectorAll('.map__map-marker');
    const activeClass = 'accordion__item--active';

    mapMarkers.forEach(marker => {
        marker.addEventListener('click', event => {
            const accordionItem = document.querySelector(`.accordion__item[data-city="${event.target.dataset.city}"]`);

            if (accordionItem && !accordionItem.classList.contains(activeClass)) {
                const accordionHead = accordionItem.querySelector('.accordion__item-head');
                accordionHead.click();
            }
            event.stopPropagation();
        });
    });
}